import React, { useState, useEffect } from "react";
import ProgressCircle from "../../../../../../../../../../../../components/ProgressCircle";
import { useNavigate } from "react-router-dom";

export default function InfoProgress({ curso }) {
  const [randomColor, setRandomColor] = useState({
    baseColor: "#000000",
    transparentColor: "#00000033",
  });

  const navigate = useNavigate();
  // Método para generar un color pastel y su versión con opacidad al 20%
  const generateRandomColor = () => {
    const hue = Math.floor(Math.random() * 360); // Tono aleatorio
    const saturation = 70; // Saturación alta para colores pastel
    const lightness = 80; // Luminosidad alta para colores pastel
    const baseColor = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    const transparentColor = `hsla(${hue}, ${saturation}%, ${lightness}%, 0.2)`; // Opacidad al 20%
    return { baseColor, transparentColor };
  };

  // useEffect para establecer los colores al cargar el componente
  useEffect(() => {
    const { baseColor, transparentColor } = generateRandomColor();
    setRandomColor({ baseColor, transparentColor });
  }, []);

  console.log(curso);

  return (
    <>
      <div
        data-figma-id="810:15823"
        class="tarjeta-curso-progreso"
        onClick={() =>
          navigate(
            `?f=cc&curso_id=${curso?.curso_id}&leccion_id=${curso?.ultima_leccion_id}`
          )
        }
      >
        <div data-figma-id="810:15835" class="tarjeta-progreso-curso-info">
          <p
            data-figma-id="810:15836"
            class="tarjeta-progreso-curso-info-titulo truncate-1-line"
          >
            {curso?.titulo_curso}
          </p>
          <p
            data-figma-id="810:15837"
            class="tarjeta-progreso-curso-lecciones-texto"
          >
            {`Leccion ${curso?.num_lecciones_progreso}`}
          </p>
          <div
            data-figma-id="810:15838"
            class="tarjeta-progreso-curso-info-progreso"
          >
            <div data-figma-id="810:15851" class="barra-progreso">
              <div
                data-figma-id="810:15853"
                class="barra-progreso-1"
                style={{ width: curso?.porcentaje_completado_leccion + "%" }}
              >
                <div data-figma-id="810:15854" class="barra-progreso-1-2"></div>
                <div class="div-block-9"></div>
              </div>
              <div data-figma-id="810:15852" class="div-block-17"></div>
            </div>
            <div data-figma-id="810:15840" class="barra-progreso-numeros">
              <p data-figma-id="810:15841" class="barra-progreso-numero-1">
                {curso?.progreso_video}
              </p>
              <p data-figma-id="810:15842" class="barra-progreso-numero-2">
                {curso?.total_tiempo_video}
              </p>
            </div>
          </div>
        </div>
        <div data-figma-id="810:15856" class="div-block-8">
          <ProgressCircle
            progress={curso?.porcentaje_completado_curso}
            color_fondo={randomColor.transparentColor} // Usa el color con opacidad
            color_progreso={randomColor.baseColor} // Usa el color base
            svgClassName="progress-circle-progreso"
            tamaño={65}
            strokeWidth={5}
            rotate={0} // Rotación de 90 grados en sentido antihorario
          />
          <p
            data-figma-id="810:15859"
            class="porcentaje-texto"
            style={{ color: randomColor.baseColor }}
          >
            {curso?.porcentaje_completado_curso}%
          </p>
        </div>
      </div>
    </>
  );
}
